import React from 'react';
import styled from 'styled-components';
import { defaultTransition } from '@peloton/styles';
import type { RelevantSongInfo } from '@engage/classes';
import { slate3, white, slate1 } from '@engage/colors';
import { spaces } from '@engage/styles';
import { label16, label12, truncate } from '@engage/typography';
import { ClassSearchCopy } from '@members/copy';
import { ClassSearch } from '@members/copy/models.generated/ClassSearch';
import { ArtistImage } from '@members/pg-search/ArtistImage';

export const RelevantSongInfoRow: React.FC<
  React.PropsWithChildren<{ relevantSongInfo: RelevantSongInfo }>
> = ({ relevantSongInfo }) => {
  const artist = {
    name: relevantSongInfo.relevantSongTitle,
    imageUrl: relevantSongInfo.relevantAlbumImageUrl,
  };
  return (
    <RelevantSongInfoContainer data-test-id="relevantSongInfoContainer">
      <MusicNoteContainer>
        <ArtistImage hasShadow={false} artist={artist} />
      </MusicNoteContainer>
      <SongTitle data-test-id="songTitle">{relevantSongInfo.relevantSongTitle}</SongTitle>
      {relevantSongInfo.numRelevantSongs && relevantSongInfo.numRelevantSongs > 1 ? (
        <NumRelevantSongs>
          <ClassSearchCopy
            id={ClassSearch.NumRelevantSongs}
            values={{ numRelevantSongs: relevantSongInfo.numRelevantSongs - 1 }}
          />
        </NumRelevantSongs>
      ) : null}
    </RelevantSongInfoContainer>
  );
};

export const RelevantSongInfoContainer = styled.div`
  width: 100%;
  height: ${spaces.xxxHuge}px;
  padding: ${spaces.small}px ${spaces.large}px;
  background-color: ${white};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  ${defaultTransition('background-color')};
`;

const MusicNoteContainer = styled.div`
  margin-right: ${spaces.small}px;
  width: ${spaces.huge}px;
  height: ${spaces.huge}px;
`;

const SongTitle = styled.div`
  ${label16};
  ${truncate(2)};
  color: ${slate3};
  flex: 1;
  padding-right: ${spaces.small}px;
`;

const NumRelevantSongs = styled.div`
  ${label12}
  color: ${slate1};
`;
